// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

body {
    min-height: 100vh;
    width: 100vw;
}

#root {
    display: flex;
    min-height: 100%;
    width: 100%;
}

.common-banner-no-radius,
.common-banner-no-radius * {
    border-radius: 0 !important;
    background-position: top !important;
}

/*Override z-index for responsive tray elements to ensure they appear above header menu*/
div[data-testid='responsive-tray-content'] {
    z-index: 1001;
}
div[data-testid='responsive-tray-background'] {
    z-index: 1001;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,WAAW;AACf;;AAEA;;IAEI,2BAA2B;IAC3B,mCAAmC;AACvC;;AAEA,wFAAwF;AACxF;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB","sourcesContent":["* {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n}\n\nbody {\n    min-height: 100vh;\n    width: 100vw;\n}\n\n#root {\n    display: flex;\n    min-height: 100%;\n    width: 100%;\n}\n\n.common-banner-no-radius,\n.common-banner-no-radius * {\n    border-radius: 0 !important;\n    background-position: top !important;\n}\n\n/*Override z-index for responsive tray elements to ensure they appear above header menu*/\ndiv[data-testid='responsive-tray-content'] {\n    z-index: 1001;\n}\ndiv[data-testid='responsive-tray-background'] {\n    z-index: 1001;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
